import { useEffect, useState } from "react";
import { analyticsPageEvent } from "../../components/Analytics";
import BreadCrumbs from "../../components/BreadCrumbs";
import { getPrivacyPolicy, getTopicByName } from "../../helper/backend-methods";
import Skeleton from "react-loading-skeleton";
import { useSearchParams } from "react-router-dom";
import "../../assets/css/--page-terms-and-condition.css";
import AppLoader from "../../components/AppLoader";



function PrivacyPolicy(props) {
  const [webURL, setWebURL] = useState(process.env.REACT_APP_WEB_URL)
  const [pageContent, setPageContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [ search, setSearch] = useSearchParams();
  const breadcrumbItems = [
    { title: "Home", link: "/" },
    { title: "Privacy Policy", link: "" },
  ];

  // useEffect(() => {
  //   if(search){
  //     if(search.get('locale')){
  //       localStorage.setItem("LANG",search.get('locale'))
  //       window.location = "/privacy-policy/app"
  //     }
  //     else{
  //       getData();
  //     }
  //   }
  //   else{
  //     getData();
  //   }
  //   window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  // }, []);


  const getData = () => {
    getTopicByName("?name=Privacy Policy").then(({ data }) => {
      setPageContent(data.Body)
      setLoading(false)
    });
    
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {/* <Breadcrumbs
        pageTile="Privacy Policy"
        breadcrumbItems={breadcrumbItems}
      /> */}
      {loading ? <div className="loader-center loader-static-pages "><AppLoader /></div> :
      <section id="termsAndConditions">
        <div className="terms-and-conditions-page">
          <div className="wrapper ">
            <div className="terms-and-conditions-layout">
              {/* <div className="terms-and-conditions-header">
                <h1>Privacy Policy</h1>
                <p className="terms-and-conditions-last-updated">
                  Last updated: November 22, 2022
                </p>
                <p className="terms-and-conditions-description">
                At <span>Main’s Country Store & Grill</span>, we value your trust and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard the information you provide when using our website, mobile application, and services.
                </p>
              </div> */}
              <div className="terms-and-conditions-content">
                <div dangerouslySetInnerHTML={{ __html: pageContent }} />
                {/* {privacyPolicyContent.map((item, index) => (
                  <div className="terms-and-conditions-content-item" key={index}>
                    <h2>{`${index + 1}. ${item.title}`}</h2>
                    <p>{item.content}</p>
                  </div>
                ))}
                <p className="terms-and-conditions-content-last">📧  support@mainsstore.com</p>
                <p className="terms-and-conditions-content-last-text">📞  (802) 555-4321</p> */}
              </div>
            
            </div>
            </div>
          </div>
        </section>
      }
    </>
  );
}
export default PrivacyPolicy;